export enum PriceAlertConfigConditionEnum {
  ALL = 'all',
  ABOVE_THRESHOLD = 'above_threshold',
  BELOW__THRESHOLD = 'below_threshold',
}

export const PriceAlertConfigConditionOptions = [
  { label: 'all', value: PriceAlertConfigConditionEnum.ALL },
  { label: 'aboveThreshold', value: PriceAlertConfigConditionEnum.ABOVE_THRESHOLD },
  { label: 'belowThreshold', value: PriceAlertConfigConditionEnum.BELOW__THRESHOLD },
];

export const getPriceAlertConfigConditions = (type: string): string => {
  const option = PriceAlertConfigConditionOptions.find((option) => option.value === type);
  return option ? option.label : type;
};
